import { memo, ChangeEvent } from "react";
import TextField from "@mui/material/TextField";
import CustomErrorText from "../../CustomErrorText";

interface Props {
  className?: string;
  inputClassName?: string;
  label: string;
  onChange: (e: ChangeEvent<any>) => void;
  value: string;
  name: string;
  touched?: boolean;
  error?: string;
  smokerTextBox?: boolean;
  handleBlur: (event: any) => void;
  requiredStar?: boolean;
  disabledField?: boolean;
  globalClassName?: string;
}
function MedicalTextBox({
  smokerTextBox,
  //  borderRound,
  className,
  globalClassName,
  label,
  inputClassName,
  onChange,
  value,
  name,
  touched,
  error,
  handleBlur,
  requiredStar,
  disabledField
}: Props) {
  return (
    <div className={`${className}`}>
      <div
        className={` bg-white border border-solid border-discoBall focus-within:border-2 focus-within:border-hotShot ${globalClassName}`}
      >
        <TextField
          fullWidth
          disabled={disabledField}
          required={requiredStar}
          variant="filled"
          label={label}
          onBlur={handleBlur}
          InputProps={{
            classes: {
              input: !smokerTextBox
                ? " !text-black !text-sm  !font-medium  !bg-white !rounded-lg !font-montserrat"
                : "!text-xs !font-medium !pt-4.5 !pb-0 !pl-3 !pr-3 !text-black !bg-white !rounded-lg !font-montserrat focus:border-hotShot",
              root: `!rounded-lg ${inputClassName}`,
              disabled: "!bg-gray-200"
            },
            disableUnderline: true
          }}
          InputLabelProps={{
            classes: {
              root: !smokerTextBox
                ? "!text-sm !leading-5 !font-medium !text-platinumGranite !font-montserrat !pt-0.5 !pb-2"
                : "!text-sm !font-medium !text-platinumGranite !font-montserrat !-mt-2",
              shrink: smokerTextBox ? "!text-purpleComet !text-xs " : "!text-purpleComet !text-xs"
            }
          }}
          onChange={onChange}
          value={value}
          name={name}
        />
      </div>

      {touched && error && (
        <CustomErrorText text={error} type="error" smokerTextField={smokerTextBox} />
      )}
    </div>
  );
}

MedicalTextBox.defaultProps = {
  // borderRound: false,
  className: "",
  inputClassName: "",
  requiredStar: false,
  touched: "",
  error: "",
  disabledField: false,
  smokerTextBox: false,
  globalClassName: "rounded-lg"
};

export default memo(MedicalTextBox);
